var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pb-1"},_vm._l((_vm.roles),function(role,i){return _c('v-chip',{key:i,staticClass:"mr-1 mt-1",attrs:{"label":"","small":_vm.small}},[_vm._v(_vm._s(_vm.roleName(role)))])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }